<template>
  <div
    class="hover-hand border-2 rounded px-4 py-2 w-full hover:shadow-lg transition-shadow duration-200 notranslate"
    :class="{
      'bg-course text-white': isSelect && partType === 'COURSE' && isLightMode(),
      'bg-challenge text-white': isSelect && partType === 'CHALLENGE' && isLightMode(),
      'bg-bookmark text-white': isSelect && partType === 'BOOKMARK' && isLightMode(),
      'hover:border-course': partType === 'COURSE' && isLightMode(),
      'hover:border-challenge': partType === 'CHALLENGE',
      'hover:border-bookmark': partType === 'BOOKMARK' && isLightMode(),
      'text-gray-900': !isSelect && isLightMode(),
      'bg-course-dark text-dark-text border-dark-900': isSelect && partType === 'COURSE' && !isLightMode(),
      'bg-challenge text-dark-text border-dark-900': isSelect && partType === 'CHALLENGE' && !isLightMode(),
      'bg-bookmark-dark text-dark-text border-dark-900': isSelect && partType === 'BOOKMARK' && !isLightMode(),
      'hover:border-course-dark': partType === 'COURSE' && !isLightMode(),
      'hover:border-bookmark-dark': partType === 'BOOKMARK' && !isLightMode(),
      'text-dark-text border-dark-400': !isSelect && !isLightMode()
    }"
    @click="onClick"
  >
    <div class="flex items-center justify-center mr-1">
      <span class="material-icons text-2xl mr-1 notranslate">
        <span v-if="partType === 'COURSE'">map</span>
        <span v-else-if="partType === 'CHALLENGE'">inbox</span>
        <span v-else>bookmark_border</span>
      </span>
      <span v-if="partType === 'COURSE'" class="text-2xl font-bold">
        {{ $t('message.course') }}
      </span>
      <span v-else-if="partType === 'CHALLENGE'" class="text-2xl font-bold">
        {{ $t('message.challenge') }}
      </span>
      <span v-else class="text-2xl font-bold">
        {{ $t('message.bookmark') }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'

export default defineComponent({
  props: {
    onClick: {
      type: Function,
      required: true
    },
    partType: {
      type: String,
      default: 'COURSE'
    },
    isSelect: {
      type: Boolean,
      required: true
    }
  },
  setup(props) {
    const { isLightMode } = useConfigStatePresenter()
    const className = props.partType.toLowerCase()
    return {
      isLightMode,
      className
    }
  }
})
</script>

<style lang="postcss" scoped>
.course {
  @apply border-course;
  transition-duration: 0.1s;
}

.course:hover {
  @apply bg-course text-white;
}

.challenge {
  @apply border-challenge;
  transition-duration: 0.1s;
}

.challenge:hover {
  @apply bg-challenge text-white;
}
</style>
